<template>
  <v-main class="zoox-component zoox-content">
    <z-header
      v-if="!hideHeader"
      with-logo
      zooxblue
      :class="{'fixed-header': fixedHeader}"
      :dark="dark"
      :is-mobile="$vuetify.breakpoint.smAndDown"
      :logo-divider="logoDivider"
      :username="username"
      :product="product"
      :lang="lang"
      :lang-options="langOptions"
      :src-avatar="srcAvatar"
      :user-email="userEmail"
      :company="company"
      @change-lang="onChangeLang"
      @logout="onClickLogout"
    >
      <template v-if="$scopedSlots['product']" v-slot:product>
        <slot name="product"></slot>
      </template>
      <slot name="toolbar" />
      <template v-if="$scopedSlots['username']" #username>
        <slot name="username" />
      </template>
    </z-header>
    <slot name="content" />
  </v-main>
</template>

<script>
/**
 * Componente de Layout que não contém opções. Útil para páginas onde não
 * tem necessidade de navegação pelo menu lateral porém já existe um usuário
 * logado na aplicação.
 *
 * @displayName Toolbar Layout
 */
export default {
  name: 'ZToolbarLayout',
  props: {
    /**
     * Define o nome do produto
     */
    product: {
      type: String,
      required: true,
    },
    /**
     * Define o nome do usuário
     */
    username: {
      type: String,
      required: false,
      default: '',
    },
    /**
     * Define a linguagem da aplicação
     */
    lang: {
      type: String,
      required: false,
      default: 'en',
    },
    /**
     * Aplica um divider entre o nome do produto e o logo
     */
    logoDivider: {
      type: Boolean,
      default: false,
    },
    /**
     * Linguagens disponíveis no select. Utilizar somente
     * en-pt-es. Ex: ['en'] -> Somente ingles
     */
    langOptions: {
      type: Array,
      required: false,
      default: () => ['pt', 'en'],
    },
    /**
     * Define a url da imagem do avatar
     */
    srcAvatar: {
      type: [String, Object],
      required: false,
    },
    /**
     * Empresa que o produto está
     */
    company: {
      type: String,
      default: '',
    },
    /**
     * Email do usuário
     */
    userEmail: {
      type: String,
      default: '',
    },

    /**
     * Define se o tema é dark
     */
    dark: {
      type: Boolean,
      default: false,
    },

    /**
     * Flag para remover o header
     */
    hideHeader: {
      type: Boolean,
      default: false,
    },

    /**
     * Flag para fixar o header
     */
    fixedHeader: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    onChangeLang(lang) {
      /**
       * Evento emitido para alterar a linguagem
       *
       * @property {String} lang - Linguagem selecionada
       */
      this.$emit('change-lang', lang)
    },
    onClickLogout() {
      /**
       * Evento emitido para fazer logout da aplicação
       */
      this.$emit('logout')
    },
  },
}
</script>

<style lang="scss" scoped>
.zoox-content {
  background-color: var(--background);
  height: 100%;
}

.fixed-header {
  position: sticky;
  top: 0;
  z-index: 1;
}
</style>
